function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.18 19.48l-2.85 2.85-.71-.71L20.25 20H2v-1h18.29l-1.64-1.65.7-.7zM9 2a3.78 3.78 0 00-4 3.5A3.777 3.777 0 009 9v8h2V4h2v13h2V4h2V2z"
});

var SvgLtr = function SvgLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 20"
  }, props), _ref);
};

export default SvgLtr;